document.addEventListener('DOMContentLoaded', () => {
  // Init Quick View modal once (global)
  initSTLQuickView();

  // IMPORTANT: Featured STL doesn't open a modal, so we must init the product cards on page load
  document.querySelectorAll('.shop-the-look[data-stl]').forEach((section) => {
    // If your featured section has data-stl-product cards directly on the page, init them
    if (section.querySelector('[data-stl-product]')) {
      initStlProducts(section);
    }
  });

  document.querySelectorAll('[data-stl]').forEach((section) => {
    const items = Array.from(section.querySelectorAll('[data-stl-item]'));
    const pagination = section.querySelector('[data-stl-pagination]');
    const perPage = parseInt(section.getAttribute('data-per-page') || '12', 10);

    const modal = section.querySelector('.stl-modal');
    const modalContent = section.querySelector('[data-stl-modal-content]');
    const overlay = section.querySelector('[data-stl-overlay]');

    // ---------- Pagination ----------
    if (items.length && pagination) {
      let currentPage = 1;
      const totalPages = Math.max(1, Math.ceil(items.length / perPage));

      function btn(label, page, opts = {}) {
        const { isArrow=false, disabled=false, active=false, ariaLabel='' } = opts;
        const classes = ['stl-page', isArrow ? 'stl-page--arrow' : '', active ? 'is-active' : '']
          .filter(Boolean).join(' ');

        return `<button class="${classes}" type="button" data-page="${page}"
          ${disabled ? 'disabled' : ''} ${active ? 'aria-current="page"' : ''}
          ${ariaLabel ? `aria-label="${ariaLabel}"` : ''}>${label}</button>`;
      }

      function renderPagination() {
        if (totalPages <= 1) { pagination.innerHTML = ''; return; }

        let html = `<nav class="stl-pagination" aria-label="Pagination">`;
        if (currentPage > 1) html += btn('‹', currentPage - 1, { isArrow:true, ariaLabel:'Previous page' });
        for (let p = 1; p <= totalPages; p++) html += btn(String(p), p, { active: p === currentPage });
        html += btn('›', currentPage + 1, { isArrow:true, disabled: currentPage === totalPages, ariaLabel:'Next page' });
        html += `</nav>`;
        pagination.innerHTML = html;

        pagination.querySelectorAll('[data-page]').forEach((el) => {
          el.addEventListener('click', () => renderPage(parseInt(el.getAttribute('data-page'), 10)));
        });
      }

      function renderPage(page) {
        if (!Number.isFinite(page)) return;
        currentPage = Math.min(Math.max(page, 1), totalPages);

        const start = (currentPage - 1) * perPage;
        const end = start + perPage;

        items.forEach((el, idx) => el.style.display = (idx >= start && idx < end) ? '' : 'none');
        renderPagination();
      }

      renderPage(1);
    }

    // ---------- STL Modal ----------
    if (!modal || !modalContent || !overlay) return;

    let lastFocus = null;

    function findTemplateByKey(key) {
      const templates = section.querySelectorAll('template[data-look-template]');
      for (const t of templates) {
        if (t.getAttribute('data-look-template') === key) return t;
      }
      return null;
    }

    function openModal(key) {
      const tpl = findTemplateByKey(key);
      if (!tpl) return;
console.log('TEsting');
      lastFocus = document.activeElement;

      modalContent.innerHTML = tpl.innerHTML;

      // IMPORTANT: attach product-card handlers (sizes/colors + quickview click)
      initStlProducts(modalContent);

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('stl-lock');
      document.body.classList.add('stl-lock');

      const closeBtn = modalContent.querySelector('[data-stl-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeModal);

      setTimeout(() => modalContent.focus(), 10);
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      modalContent.innerHTML = '';
      document.documentElement.classList.remove('stl-lock');
      document.body.classList.remove('stl-lock');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    overlay.addEventListener('click', closeModal);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    section.addEventListener('click', (e) => {
      const card = e.target.closest('[data-look-key]');
      if (!card) return;

      const key = card.getAttribute('data-look-key');
      if (!key) return;

      openModal(key);
    });
  });
});

/* ------------------------
   Product interactions (STL cards inside Look modal)
------------------------ */
function initStlProducts(container) {
  const swatchMap = getSwatchColorMap();

  container.querySelectorAll('[data-stl-product]').forEach((card) => {
    const variantsEl = card.querySelector('[data-stl-variants]');
    const variantInput = card.querySelector('[data-stl-variant-id]');
    if (!variantsEl || !variantInput) return;

    let variants = [];
    try { variants = JSON.parse(variantsEl.textContent || '[]'); } catch(e) {}

    const current = { options: [] };
    const first = variants.find(v => v.available) || variants[0];
    if (first && Array.isArray(first.options)) current.options = [...first.options];

    // swatch dot backgrounds
    card.querySelectorAll('.stl-swatch').forEach((btn) => {
      const value = (btn.getAttribute('data-option-value') || '').trim();
      const dot = btn.querySelector('.stl-swatch__dot');
      if (!dot) return;
      const cssColor = resolveColor(value, swatchMap);
      if (cssColor) dot.style.background = cssColor;
    });

    function groupOrder() {
      const optionButtons = Array.from(card.querySelectorAll('[data-stl-option]'));
      const order = [];
      optionButtons.forEach((b) => {
        const n = b.getAttribute('data-option-name');
        if (n && !order.includes(n)) order.push(n);
      });
      return order;
    }

    function syncActiveUI(){
      card.querySelectorAll('[data-stl-option]').forEach((btn) => btn.classList.remove('is-active'));

      const optionButtons = Array.from(card.querySelectorAll('[data-stl-option]'));
      const order = groupOrder();

      order.forEach((name, idx) => {
        const selected = current.options[idx];
        if (!selected) return;

        optionButtons.forEach((btn) => {
          if (btn.getAttribute('data-option-name') === name && btn.getAttribute('data-option-value') === selected) {
            btn.classList.add('is-active');
          }
        });
      });
    }

    function findMatchingVariant(){
      const order = groupOrder();

      return variants.find(v => {
        if (!Array.isArray(v.options)) return false;
        for (let i = 0; i < order.length; i++){
          if (current.options[i] && v.options[i] !== current.options[i]) return false;
        }
        return true;
      });
    }

    function setVariantFromSelection(){
      const match = findMatchingVariant();
      if (match) variantInput.value = match.id;
    }

    // Prevent navigating when clicking options / quickview (inside <a>)
    card.querySelectorAll('[data-stl-option], [data-stl-quickview]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    });

    // Option clicks
    card.querySelectorAll('[data-stl-option]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const optName = btn.getAttribute('data-option-name');
        const optVal = btn.getAttribute('data-option-value');

        const order = groupOrder();
        const idx = order.indexOf(optName);
        if (idx === -1) return;

        current.options[idx] = optVal;
        syncActiveUI();
        setVariantFromSelection();
      });
    });

    // Quick View open (cart icon)
    const qvBtn = card.querySelector('[data-stl-quickview]');
    if (qvBtn) {
      qvBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const url = qvBtn.getAttribute('data-product-url');
        if (window.STL_openQuickView) window.STL_openQuickView(url);
      });
    }

    // Init
    syncActiveUI();
    setVariantFromSelection();
  });
}

/* ------------------------
   Quick View modal (Impulse)
   - Loads main-product section
   - Hydrates blocks from full PDP if no form exists
   - Keeps JSON scripts
------------------------ */
function initSTLQuickView(){
  if (window.__stlQvInit) return;
  window.__stlQvInit = true;

  const qv = document.querySelector('[data-stl-qv]');
  if (!qv) return;

  const overlay = qv.querySelector('[data-stl-qv-overlay]');
  const closeBtn = qv.querySelector('[data-stl-qv-close]');
  const panel = qv.querySelector('[data-stl-qv-panel]');
  const content = qv.querySelector('[data-stl-qv-content]');

  const SECTION_ID = 'main-product';
  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');

  function stripScriptsKeepJSON(root){
    root.querySelectorAll('script').forEach((s) => {
      const type = (s.getAttribute('type') || '').toLowerCase();
      if (type === 'application/json') return; // keep variants json
      s.remove();
    });
  }

  function hideLoadingOverlays(root){
    root.querySelectorAll('.loading-overlay, .loading').forEach(el => (el.style.display = 'none'));
  }

  function hasProductForm(root){
    return !!(
      root.querySelector('form[action^="/cart/add"]') ||
      root.querySelector('product-form form[action^="/cart/add"]') ||
      root.querySelector('.product-form form[action^="/cart/add"]')
    );
  }

  function injectSectionHTML(html) {
    const doc = parseHTML(html);
    const sectionEl =
      doc.querySelector('.shopify-section') ||
      doc.querySelector('[id^="shopify-section-"]') ||
      doc.querySelector('[data-section-id]');

    content.innerHTML = sectionEl ? sectionEl.innerHTML : html;
    stripScriptsKeepJSON(content);
    hideLoadingOverlays(content);
  }

  async function hydrateFromFullPDP(productUrl, signal){
    const u = new URL(productUrl, window.location.origin);

    const res = await fetch(u.toString(), {
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' },
      cache: 'no-store',
      signal
    });

    if (!res.ok) return;

    const html = await res.text();
    const doc = parseHTML(html);

    // grab the real product form + option UI from full PDP
    const pdpInfo =
      doc.querySelector('[data-product-blocks]') ||
      doc.querySelector('.product__info') ||
      doc.querySelector('.product-single__meta') ||
      null;

    const pdpForm =
      doc.querySelector('form[action^="/cart/add"]') ||
      doc.querySelector('product-form form[action^="/cart/add"]') ||
      null;

    if (!pdpInfo && !pdpForm) return;

    const target =
      content.querySelector('[data-product-blocks]') ||
      content.querySelector('.product__info') ||
      content.querySelector('.product-single__meta') ||
      content;

    target.innerHTML = pdpInfo ? pdpInfo.innerHTML : pdpForm.outerHTML;

    // after injecting, clean scripts but keep json
    stripScriptsKeepJSON(content);
    hideLoadingOverlays(content);
  }

  async function openQuickView(productUrl){
    if (!productUrl) return;

    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set('section_id', SECTION_ID);

    qv.classList.add('is-open');
    qv.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('stl-lock');
    document.body.classList.add('stl-lock');

    content.innerHTML = '<div style="padding:16px;">Loading…</div>';

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);

    try {
      const res = await fetch(url.toString(), {
        credentials: 'same-origin',
        headers: { 'Accept': 'text/html' },
        cache: 'no-store',
        signal: controller.signal
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const html = await res.text();
      injectSectionHTML(html);

      // If section didn’t include the product form/options, fallback to full PDP
      if (!hasProductForm(content)) {
        await hydrateFromFullPDP(productUrl, controller.signal);
      }

      // bind variants if we have form + json
      STL_initImpulseVariants(content);

      setTimeout(() => panel && panel.focus(), 30);
    } catch (e) {
      console.warn('[STL QV] Error:', e);
      content.innerHTML = `<div style="padding:16px;">Could not load product.<br><small>${String(e.message || e)}</small></div>`;
    } finally {
      clearTimeout(timeout);
    }
  }

  function closeQuickView(){
    qv.classList.remove('is-open');
    qv.setAttribute('aria-hidden', 'true');
    content.innerHTML = '';
    document.documentElement.classList.remove('stl-lock');
    document.body.classList.remove('stl-lock');
  }

  overlay && overlay.addEventListener('click', closeQuickView);
  closeBtn && closeBtn.addEventListener('click', closeQuickView);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && qv.classList.contains('is-open')) closeQuickView();
  });

  window.STL_openQuickView = openQuickView;
}

/* ------------------------
   Manual variant init (radios/selects)
------------------------ */
function STL_initImpulseVariants(root) {
  const form =
    root.querySelector('form[action^="/cart/add"]') ||
    root.querySelector('product-form form[action^="/cart/add"]') ||
    root.querySelector('.product-form form[action^="/cart/add"]');

  if (!form) {
    console.warn('[STL] No product form found in Quick View.');
    return;
  }

  let variants = null;

  const jsonEl =
    root.querySelector('script[type="application/json"][data-product-json]') ||
    root.querySelector('script[type="application/json"][data-variant-json]') ||
    root.querySelector('script[type="application/json"][id*="ProductJson"]') ||
    root.querySelector('script[type="application/json"][id*="product-json"]');

  if (jsonEl) {
    try {
      const data = JSON.parse(jsonEl.textContent || '{}');
      variants = Array.isArray(data?.variants) ? data.variants : (Array.isArray(data) ? data : null);
    } catch(e) {}
  }

  if (!Array.isArray(variants) || !variants.length) return;

  const idInput = form.querySelector('input[name="id"]');
  if (!idInput) return;

  const radios = Array.from(form.querySelectorAll('input[type="radio"][name^="options["]'));
  const selects = Array.from(form.querySelectorAll('select[name^="options["]'));

  function getRadioNames() {
    return [...new Set(radios.map(r => r.name))];
  }

  function getSelectedOptions() {
    if (radios.length) {
      const names = getRadioNames();
      return names.map((n) => {
        const checked = form.querySelector(`input[type="radio"][name="${CSS.escape(n)}"]:checked`);
        return checked ? checked.value : null;
      });
    }
    if (selects.length) return selects.map(s => s.value || null);
    return [];
  }

  function findVariant(opts) {
    return variants.find(v => {
      if (!Array.isArray(v.options)) return false;
      for (let i = 0; i < opts.length; i++) {
        if (opts[i] && v.options[i] !== opts[i]) return false;
      }
      return true;
    });
  }

  function setATCState(variant) {
    const atc =
      form.querySelector('button[name="add"]') ||
      form.querySelector('button[type="submit"]') ||
      form.querySelector('[data-add-to-cart]');

    if (!atc) return;

    if (variant && variant.available) {
      atc.disabled = false;
      atc.removeAttribute('aria-disabled');
    } else {
      atc.disabled = true;
      atc.setAttribute('aria-disabled', 'true');
    }
  }

  function sync() {
    const opts = getSelectedOptions();
    const match = findVariant(opts);

    if (match) {
      idInput.value = match.id;
      setATCState(match);
    } else {
      setATCState(null);
    }
  }

  radios.forEach(r => r.addEventListener('change', sync));
  selects.forEach(s => s.addEventListener('change', sync));
  sync();
}

/* ------------------------
   Color helpers
------------------------ */
function resolveColor(valueRaw, map) {
  if (!valueRaw) return null;
  const v = valueRaw.trim();

  if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(v)) return v;
  if (window.CSS && CSS.supports && CSS.supports('color', v)) return v;

  const key = (v || '').toLowerCase().replace(/\s+/g,'').replace(/[-_]/g,'');
  return map[key] || null;
}

function getSwatchColorMap() {
  return {
    black:'#000000', white:'#ffffff', ivory:'#f6f1e6', cream:'#f3ead6', beige:'#e6d5b8',
    brown:'#6b4f3b', grey:'#9aa0a6', gray:'#9aa0a6', navy:'#0b1f3a', blue:'#1f4aa8',
    red:'#c1121f', green:'#1f7a3a', pink:'#e8a2b6', purple:'#6f42c1', orange:'#f2994a',
    nero:'#000000', bianco:'#ffffff', avorio:'#f6f1e6', panna:'#f3ead6', beige:'#e6d5b8',
    marrone:'#6b4f3b', grigio:'#9aa0a6', blu:'#1f4aa8', rosso:'#c1121f', verde:'#1f7a3a',
    rosa:'#e8a2b6', viola:'#6f42c1', arancione:'#f2994a'
  };
}